'use es6';

import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["children", "onCalculateContents", "onPageChange", "title", "totalCount", "isLoadingPageOnDemand", "page"];
import { Children, Fragment, useEffect, useState } from 'react';
import styled from 'styled-components';
import { useMemo } from 'react';
import UICardGrid from 'UIComponents/card/UICardGrid';
import UIPaginator from 'UIComponents/paginator/UIPaginator';
import UISection from 'UIComponents/section/UISection';
import UISubheader from 'UIComponents/layout/UISubheader';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const StyledUISubheader = styled(UISubheader).withConfig({
  displayName: "PaginatedUICardGrid__StyledUISubheader",
  componentId: "xemkrp-0"
})(["padding:20px 0 0;"]);
const UICardGridStyled = styled(UICardGrid).withConfig({
  displayName: "PaginatedUICardGrid__UICardGridStyled",
  componentId: "xemkrp-1"
})(["grid-template-columns:repeat(auto-fill,minmax(298px,1fr));"]);
const DEFAULT_PAGE = 1;
const PER_PAGE = 12;
const PaginatedUICardGrid = _ref => {
  let {
      children,
      onCalculateContents,
      onPageChange,
      title,
      totalCount,
      isLoadingPageOnDemand,
      page
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  const [currentPage, setPage] = useState(page || DEFAULT_PAGE);
  const childrenLength = totalCount || Children.count(children);
  const sliceStart = (currentPage - 1) * PER_PAGE;
  const sliceEnd = currentPage * PER_PAGE;
  const childrenToRender = useMemo(() => {
    if (isLoadingPageOnDemand) {
      return children;
    } else {
      return children.slice(sliceStart, sliceEnd);
    }
  }, [children, isLoadingPageOnDemand, sliceEnd, sliceStart]);
  const changePage = value => {
    setPage(value);
    if (onPageChange) {
      onPageChange(value);
    }
  };
  useEffect(() => {
    if (onCalculateContents) {
      onCalculateContents({
        startCard: sliceStart + 1,
        endCard: sliceStart + childrenToRender.length,
        cardsTotal: childrenLength
      });
    }
  }, [onCalculateContents, childrenLength, sliceStart, childrenToRender.length]);
  if (sliceStart > childrenLength) {
    changePage(1);
    return null;
  }
  return /*#__PURE__*/_jsxs(Fragment, {
    children: [!!title && /*#__PURE__*/_jsx(StyledUISubheader, {
      title: title
    }), /*#__PURE__*/_jsx(UISection, {
      children: /*#__PURE__*/_jsx(UICardGridStyled, Object.assign({}, rest, {
        children: childrenToRender
      }))
    }), childrenLength > PER_PAGE && /*#__PURE__*/_jsx(UISection, {
      children: /*#__PURE__*/_jsx(UIPaginator, {
        defaultPage: currentPage,
        onPageChange: evt => changePage(evt.target.value),
        pageCount: Math.ceil(childrenLength / PER_PAGE),
        showFirstLastButtons: true
      })
    })]
  });
};
export default PaginatedUICardGrid;